import { createFileRoute } from '@tanstack/react-router';
import { AdminTenants } from './admin.tenants';

export const Route = createFileRoute('/instructor/organization')({
  component: () => <AdminTenants basePath="/instructor" />,
});
